export default __webpack_public_path__ + "static/media/retirement-illustration.714bf039.png";